//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <svg
    width="80"
    height="70"
    viewBox="0 0 80 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="24.0024"
      y="9.08242"
      width="33.0774"
      height="51.6899"
      rx="4.74635"
      transform="rotate(-0.138656 24.0024 9.08242)"
      :style="{ stroke: store.state.Style.themeColor }"
      stroke-width="2"
    />
    <circle
      cx="30.1416"
      cy="16.1258"
      r="2.2579"
      transform="rotate(-0.582258 30.1416 16.1258)"
      :style="{ fill: store.state.Style.themeColor }"
    />
    <circle
      cx="30.1098"
      cy="21.8509"
      r="2.2579"
      transform="rotate(-0.582258 30.1098 21.8509)"
      :style="{ fill: store.state.Style.themeColor }"
    />
    <circle
      cx="35.0766"
      cy="19.1841"
      r="2.2579"
      transform="rotate(-0.582258 35.0766 19.1841)"
      :style="{ fill: store.state.Style.themeColor }"
    />
  </svg>
</template>

<script setup>
import { useStore } from "vuex";
const store = useStore();
</script>
